import { render, staticRenderFns } from "./AdvertisementDetailsDrawer.vue?vue&type=template&id=04c1d04e&scoped=true"
import script from "./AdvertisementDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./AdvertisementDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementDetailsDrawer.vue?vue&type=style&index=0&id=04c1d04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1d04e",
  null
  
)

export default component.exports